// extracted by mini-css-extract-plugin
export var downArrow = "_6l-0";
export var label = "_6l-1";
export var treatmentCard = "_6l-3";
export var upArrow = "_6l-2";